import { endpointTripletex } from './base.config';

export const tripletexCompanyContact = {
  getCompanyContacts:  `${endpointTripletex}/tripletex/company-contacts`,
  getCompanyContactCount: `${endpointTripletex}/tripletex/company-contacts/count`,
  deleteContact: `${endpointTripletex}/tripletex/company-contacts`,
};
